import React from 'react';
import { Grid, Button, FormControl, FormControlLabel, Checkbox, Typography, CircularProgress } from '@material-ui/core';

interface Props {
  salesRoute: SalesRoute[];
  zone: ZoneModel[];
  isLoading: boolean;
  handleChangeRoute: (ZoneId: number) => void;
  handleOnSubmit: () => void;
  handleOnCancel: React.MouseEventHandler;
  handleSelectAll: () => void;
  handleClearAll: () => void;
}
const RouteForm: React.FC<Props> = props => {
  const { salesRoute, zone, isLoading, handleChangeRoute, handleOnSubmit, handleOnCancel, handleSelectAll, handleClearAll } = props;

  return (
    <form>
      <Grid container direction='row'>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          {zone.length === salesRoute.length ? (
            <Button disabled={zone.length == 0} color='default' onClick={handleClearAll}>
              Hapus Semua
            </Button>
          ) : (
            <Button disabled={zone.length == 0} color='default' onClick={handleSelectAll}>
              Pilih Semua
            </Button>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ul style={{ listStyle: 'none', columnCount: 4 }}>
            {zone.length > 0 ? (
              zone.map((value, index) => (
                <li key={index}>
                  <FormControl component='fieldset'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() => handleChangeRoute(value.id)}
                          color='primary'
                          name={value.name}
                          checked={salesRoute.some(_value => _value.ZoneId === value.id)}
                        />
                      }
                      label={value.name}
                    />
                  </FormControl>
                </li>
              ))
            ) : (
              <Typography> Data Belum Ada</Typography>
            )}
          </ul>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container direction='row' justify='flex-end' spacing={2}>
          <Grid item>
            <Button color='secondary' onClick={handleOnCancel} disabled={isLoading}>
              Batal
            </Button>
          </Grid>
          <Grid item>
            <Button disabled={isLoading} onClick={handleOnSubmit}>
              {isLoading ? <CircularProgress size={20} color='primary' /> : 'Simpan'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default RouteForm;
